module.exports = __webpack_public_path__ + "static/img/growup-ad.02d49fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/growup-ad.png
// module id = ZqyQ
// module chunks = 0